
  var _styles = {
  "task-list-modal": {
    "display": "flex",
    "flexDirection": "column",
    "width": "10rem",
    "height": "14.66667rem",
    "borderTopLeftRadius": "0.53333rem",
    "borderTopRightRadius": "0.53333rem",
    "overflow": "hidden",
    "backgroundColor": "rgb(239,247,255)"
  },
  "task-list-modal__background": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "10rem",
    "height": "14.61333rem"
  },
  "task-list-modal__header": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "10rem",
    "height": "1.44rem"
  },
  "task-list-modal__header-image": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "10rem",
    "height": "1.44rem"
  },
  "task-list-modal__title": {
    "fontSize": "0.48rem",
    "fontWeight": "500",
    "color": "rgb(17,17,17)",
    "lineHeight": "0.86667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__close-btn": {
    "position": "absolute",
    "top": "0.48rem",
    "right": "0.48rem",
    "width": "0.48rem",
    "height": "0.48rem"
  },
  "task-list-modal__close-icon": {
    "width": "0.48rem",
    "height": "0.48rem"
  },
  "task-list-modal__empty": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "10rem",
    "height": "8rem"
  },
  "task-list-modal__empty-text": {
    "fontSize": "0.37333rem",
    "color": "rgb(85,85,85)",
    "lineHeight": "0.66667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__list-wrapper": {
    "display": "flex",
    "flexDirection": "column",
    "flex": 1,
    "width": "10rem",
    "overflow": "hidden"
  },
  "task-list-modal__scroll": {
    "flex": 1
  },
  "task-list-modal__list": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "width": "10rem",
    "paddingTop": "0.21333rem"
  },
  "task-list-modal__list-footer": {
    "width": "9.36rem",
    "height": "0.53333rem"
  },
  "task-list-modal__item": {
    "display": "flex",
    "flexDirection": "column",
    "width": "9.36rem",
    "height": "2.05333rem"
  },
  "task-list-modal__item-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "width": "9.36rem",
    "height": "2.04rem",
    "paddingLeft": "0.21333rem",
    "paddingRight": "0.21333rem"
  },
  "task-list-modal__item-icon": {
    "width": "1.17333rem",
    "height": "1.17333rem",
    "borderRadius": "0.42667rem",
    "backgroundColor": "rgb(217,236,255)",
    "marginRight": "0.26667rem"
  },
  "task-list-modal__item-main": {
    "display": "flex",
    "flexDirection": "column",
    "width": "5.36rem",
    "marginRight": "0.21333rem"
  },
  "task-list-modal__item-title": {
    "width": "100%",
    "fontSize": "0.37333rem",
    "fontWeight": "500",
    "color": "rgb(17,17,17)",
    "lineHeight": "0.66667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__item-desc": {
    "fontSize": "0.32rem",
    "color": "rgb(153,153,153)",
    "lineHeight": "0.58667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__item-progress": {
    "fontSize": "0.32rem",
    "color": "rgb(85,85,85)",
    "lineHeight": "0.58667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__item-btn-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "task-list-modal__item-btn-image": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.92rem",
    "height": "0.85333rem"
  },
  "task-list-modal__item-btn-image-text": {
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.58667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__item-btn": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.92rem",
    "height": "0.85333rem",
    "borderRadius": "0.66667rem",
    "overflow": "hidden"
  },
  "task-list-modal__item-btn--unfinished": {
    "backgroundColor": "rgba(0,0,0,0)"
  },
  "task-list-modal__item-btn--finished": {
    "backgroundColor": "rgba(0,0,0,0)",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)"
  },
  "task-list-modal__item-btn--impossible": {
    "backgroundColor": "rgba(0,0,0,0)",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(204,204,204)"
  },
  "task-list-modal__item-btn-gradient": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.92rem",
    "height": "0.85333rem",
    "borderRadius": "0.66667rem"
  },
  "task-list-modal__item-btn-text": {
    "position": "relative",
    "fontSize": "0.32rem",
    "fontWeight": "500",
    "lineHeight": "0.58667rem",
    "fontFamily": "PingFang SC"
  },
  "task-list-modal__item-btn-text--unfinished": {
    "color": "rgb(255,255,255)"
  },
  "task-list-modal__item-btn-text--finished": {
    "color": "rgb(85,85,85)"
  },
  "task-list-modal__item-btn-text--impossible": {
    "color": "rgb(153,153,153)"
  },
  "task-list-modal__item-divider": {
    "width": "7.73333rem",
    "height": "0.01333rem",
    "marginLeft": "1.33333rem",
    "backgroundColor": "rgb(204,204,204)",
    "opacity": 0.7
  }
};



  module.exports = _styles;
  